/**
 * Tailwind translations of the legacy typography primitives from
 * app/static/js/site/creation-tools/components/typography.ts:5-63. Only
 * the primitives an existing or upcoming consumer needs are ported here.
 *
 * Legacy sets `text-align: inherit` on each of these — not a color rule.
 * Tailwind's `text-inherit` utility sets `color: inherit`, a different
 * property, so the arbitrary property `[text-align:inherit]` is used
 * instead to match legacy exactly.
 *
 * `Subtitle`'s nested `i`/`svg` rules (typography.ts:31-46) apply to icon
 * children and are not reproduced here — apply `mr-[8px] align-top`
 * directly to the icon element at each call site instead.
 */
export const title = 'm-0 mb-[20px] text-[24px] font-[900] [text-align:inherit] antialiased'
export const subtitle = 'm-0 mb-[10px] text-[15px] font-bold [text-align:inherit] antialiased'
export const text = 'm-0 mb-[12px] max-w-[400px] leading-[1.3] [text-align:inherit]'
export const textSmall = 'm-0 mb-[12px] max-w-[400px] text-[14px] leading-[1.3] [text-align:inherit]'
